<template>
  <div>
    <px-view-header title="Cadastro de Mensagem"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingMensagem">
      <px-circular-loading/>
    </div>
    <v-container v-else>
      <v-row dense>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="100"
            class="rounded-tag-small"
            label="Código"
            v-model="mensagemPersonalizada.codigoInterno"/>
        </v-col>
        <v-col cols="12" sm="9">
          <v-textarea
            dense
            outlined
            rows="1"
            required
            auto-grow
            class="required rounded-tag-small"
            label="Mensagem"
            counter="1500"
            :error="$v.mensagemPersonalizada.mensagem.$error"
            @blur="$v.mensagemPersonalizada.mensagem.$touch()"
            v-model="mensagemPersonalizada.mensagem"/>
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Padrão"
                    color="primary"
                    v-model="mensagemPersonalizada.padrao"/>
        </v-col>
      </v-row>
      <div class="mt-0">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { parseBooleanQueryParam } from '@/utils/query-param-utils';
import MessageService from '../service/messages-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingMensagem: false,
      mensagemPersonalizada: {
        mensagem: null,
        codigoInterno: null,
        padrao: false,
      },
      idMensagem: this.$route.params.id,
      isCopy: parseBooleanQueryParam(this.$route.query.isCopy),
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Mensagem' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.messages' });
    },
    buildCopy(data) {
      const mensagemPersonalizada = { ...data };
      mensagemPersonalizada.id = undefined;
      mensagemPersonalizada.codigoInterno = null;
      mensagemPersonalizada.padrao = false;
      return mensagemPersonalizada;
    },
    getMensagemPersonalizada() {
      this.loadingMensagem = true;
      MessageService.get(this.idMensagem)
        .then((response) => {
          if (this.isCopy) {
            this.mensagemPersonalizada = this.buildCopy(response.data);
            return;
          }
          this.mensagemPersonalizada = response.data;
        })
        .finally(() => {
          this.loadingMensagem = false;
        });
    },
    buildMensagem() {
      const mensagemPersonalizada = { ...this.mensagemPersonalizada };
      mensagemPersonalizada.mensagem = mensagemPersonalizada.mensagem.trim();
      mensagemPersonalizada.codigoInterno = mensagemPersonalizada.codigoInterno
        ? mensagemPersonalizada.codigoInterno.trim() : null;
      return mensagemPersonalizada;
    },
    salvar() {
      this.loading = true;
      MessageService.save(this.buildMensagem())
        .then(() => {
          this.$toast('Mensagem criado com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.idMensagem) {
      this.getMensagemPersonalizada();
    }
  },
  validations: {
    mensagemPersonalizada: {
      mensagem: {
        required,
      },
    },
  },
};
</script>
